/**
 * Define the api types we can call in display from Promotion Editor
 */
const displayApis = {
  UPDATE_PROMOTION: 'preview:update:promotion',
  RESET_SESSION:    'reset:session',
};

export default displayApis;
